"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = exports.Link = void 0;
var _react = require("react");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _Copy = _interopRequireDefault(require("../Copy"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "color", "onCopy", "clipboardCopy", "href", "to", "component", "target", "underline", "align", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'link';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      cursor: 'pointer'
    },
    copyButton: {
      marginLeft: theme.spacing(1),
      width: '40px',
      height: '40px'
    },
    fixButtonTextAlign: {
      textAlign: 'inherit'
    },
    fixButtonText: {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      fontFamily: 'inherit'
    },
    fixUnderlineNone: {
      '&:hover': {
        textDecoration: 'none'
      }
    }
  };
});
var Link = exports.Link = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? '' : _ref$children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    onCopy = _ref.onCopy,
    _ref$clipboardCopy = _ref.clipboardCopy,
    clipboardCopy = _ref$clipboardCopy === void 0 ? false : _ref$clipboardCopy,
    href = _ref.href,
    to = _ref.to,
    componentProp = _ref.component,
    target = _ref.target,
    underlineProp = _ref.underline,
    align = _ref.align,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ggLinkClasses = useStyles({
    name: 'GgLink'
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    _link = _useState2[0],
    setLink = _useState2[1];
  var handleLinkRef = (0, _useForkRef["default"])(setLink, ref);
  var blank = target === '_blank';

  // webkit-line-clamp doesn't apply  to button  https://stackoverflow.com/questions/68673034/webkit-line-clamp-does-not-apply-to-buttons
  // const button = !to && !href;
  // const component = componentProp || (button ? 'button' : undefined);
  var component = componentProp;
  var underline = underlineProp || (blank ? 'always' : 'hover');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Link["default"], _objectSpread(_objectSpread({}, props), {}, {
      color: color,
      ref: handleLinkRef,
      "data-cy": dataCy,
      href: href,
      to: to,
      target: target,
      component: component,
      underline: underline,
      className: (0, _clsx2["default"])(ggLinkClasses.root, _defineProperty(_defineProperty(_defineProperty({}, ggLinkClasses.fixButtonTextAlign, component === 'button' && (!align || align === 'inherit')), ggLinkClasses.fixButtonText, component === 'button'), ggLinkClasses.fixUnderlineNone, underlineProp === 'none'), className),
      children: children
    })), clipboardCopy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: 'Copy link',
      wrapper: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Copy["default"], {
        onCopy: onCopy,
        value: _link === null || _link === void 0 ? void 0 : _link.href,
        className: ggLinkClasses.copyButton
      })
    }) : null]
  });
});
var _default = exports["default"] = Link;